import React from 'react'
import './Fakultet.css'
import {Link} from 'react-router-dom'
import Unvrimg from '../../assets/Fakultet/Unvrimg.png'
import Counter from '../Home/Counter/Counter'
import Circle from '../../assets/Fakultet/circle.png'
 const  Fakultet=()=> {
  return (
    <>
    <div className="Navigator">
       <div className="Navigator__from"><Link to="/">Home</Link></div>
       <div className="Navigator__line"></div>
       <div className="Navigator__to">Fakultet</div>
     </div>
    <div className='Fakultet'>
     
     <div className='FakWrapper'>
       <div className='topimg'>
         <img src={Unvrimg}  alt="" />
       </div>
      
      <div className='Infoo'>
        <div className='Infoo__head'>Amaliy matematika va inovatsion texnologiyalar fakulteti haqida ma’lumot</div>
        <div className='Infoo__title'>Amaliy matematika va intellektual texnologiyalar fakulteti O‘zbekiston Respublikasi Prezidentining 2019 yil 17 iyundagi “2019-2023 yillarda Mirzo Ulug‘bek nomidagi O‘zbekiston Milliy universitetida talab yuqori bo‘lgan malakali kadrlar tayyorlash tizimini tubdan takomillashtirish va ilmiy salohiyatni rivojlantirish chora-tadbirlari to‘g‘risida”gi 4358-son qarori asosida asosida tashkil etilgan. Fakultetning maqsadi matematik fanlar, raqamli va axborot texnologiyalari hamda sun'iy intellektni amaliyotga joriy etish bo‘yicha malakali kadrlar tayyorlashdan iborat.</div>
      </div>

      <Counter/>

      <div className='yunalishlar'>
        <div className='yunalishlar__box'>
          <h1 className='yunalishlar__box-name'>1.Amaliy matematika va kompyuter tahlili</h1>
          <img src={Circle} className='yunalishlar__box-circle' alt="" />
        </div>
        <div className='yunalishlar__box'>
          <h1 className='yunalishlar__box-name'>1.Amaliy matematika va kompyuter tahlili</h1>
          <img src={Circle} className='yunalishlar__box-circle' alt="" />
        </div>
        <div className='yunalishlar__box'>
          <h1 className='yunalishlar__box-name'>1.Amaliy matematika va kompyuter tahlili</h1>
          <img src={Circle} className='yunalishlar__box-circle' alt="" />
        </div>
        <div className='yunalishlar__box'>
          <h1 className='yunalishlar__box-name'>1.Amaliy matematika va kompyuter tahlili</h1>
          <img src={Circle} className='yunalishlar__box-circle' alt="" />
        </div>

      </div>

      <div className='kontigent'>
        <h4 className='kontigent__name'>Talabalar kontigenti</h4>
        <div className='kontigent__box'>
          <div className='chart'>
            <h1>2166</h1>
            <p>Talabalar kontigenti</p>
          </div>
          <div className='kontigent__box-line'></div>
          <div className='chart'>
            <h1>1203</h1>
            <p>Kunduzgi</p>
          </div>
          <div className='kontigent__box-line'></div>
          <div className='chart'>
            <h1>426</h1>
            <p>Kechki</p>
          </div>
          <div className='kontigent__box-line'></div>
          <div className='chart'>
            <h1>403</h1>
            <p>Sirti</p>
          </div>
         
        </div>
      </div>

      <div className='studentNum'>
      <h4 className='kontigent__name'>Ta'lim dasturlar soni</h4>
        <div className='kontigent__box'>
          <div className='chart'>
            <h1>5 ta</h1>
            <p>Kunduzgi bakalavir</p>
          </div>
          <div className='kontigent__box-line'></div>
          <div className='chart'>
            <h1>2 ta </h1>
            <p>Sirtqi</p>
          </div>
          <div className='kontigent__box-line'></div>
          <div className='chart'>
            <h1>1 ta</h1>
            <p>Kechki</p>
          </div>
          <div className='kontigent__box-line'></div>
          <div className='chart'>
            <h1>5 ta</h1>
            <p>Magistratura</p>
          </div>
          <div className='kontigent__box-line'></div>
          <div className='chart'>
            <h1>1 ta</h1>
            <p>Ilmiy daraja beruvchi kengash</p>
          </div>
         
        </div>
      </div>
      </div>
    </div>
    </>
  )
}
export default Fakultet
